/** @format */

import { RoadFlexAdvantagesType } from "@roadflex/types";
import { useEffect, useRef, useState } from "react";

interface Panel3Props {
  advantages: RoadFlexAdvantagesType[];
  advantagesMutual: RoadFlexAdvantagesType[];
}

export default function Panel3(props: Panel3Props) {
  const { advantages = [], advantagesMutual = [] } = props;
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const topPosition = sectionRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (topPosition < windowHeight * 0.9) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div
      className={`transition-all duration-700 ease-in-out transform text-darkblue container w-full py-14 md:py-32 ${
        isVisible ? "translate-y-0 opacity-100" : "-translate-y-40 opacity-0"
      }`}
      ref={sectionRef}
    >
      <div className="mb-8 text-3xl text-center md:text-4xl 3xl:text-5xl">
        <span className="font-bold">Why Partner with RoadFlex?</span>
      </div>
      <div className="flex flex-wrap justify-center xl:justify-between gap-y-16 gap-x-12">
        {advantages.length > 0 &&
          advantages.map((advantage, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center text-center w-full max-w-[380px] hover:animate-pulseonce"
            >
              <div className="static">
                <div className="relative">
                  <div className="absolute inset-0 blur from-orange-500 via-cyan-500 to-green-500 bg-gradient-to-br"></div>
                  <div className="relative bg-white border-gray-300 rounded-lg shadow-sm min-h-[240px] p-8 m-[2px]">
                    <div className="mt-8 text-lg font-semibold text-orange-500 md:text-xl">
                      {advantage.heading}
                    </div>
                    <div className="mt-4 text-base">
                      {advantage.text1}
                      <br className="hidden md:block"></br> {advantage.text2}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="mt-32 mb-8 text-3xl text-center md:text-4xl 3xl:text-5xl">
        <span className="font-bold">How RoadFlex Partners With You</span>
      </div>
      <div className="mb-8 text-base text-center text-black md:text-lg 3xl:text-xl">
        <span className="">
          Enjoy the value-add of mutually beneficial opportunities
        </span>
      </div>
      <div className="flex flex-wrap justify-center xl:justify-between gap-y-16 gap-x-12">
        {advantagesMutual.length > 0 &&
          advantagesMutual.map((advantage, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center text-center w-full max-w-[380px] hover:animate-pulseonce"
            >
              <div className="static">
                <div className="relative">
                  <div className="absolute inset-0 blur from-orange-500 via-cyan-500 to-green-500 bg-gradient-to-br"></div>
                  <div className="relative bg-white border-gray-300 rounded-lg shadow-sm min-h-[240px] p-8 m-[2px]">
                    <div className="mt-8 text-lg font-semibold text-orange-500 md:text-xl">
                      {advantage.heading}
                    </div>
                    <div className="mt-4 text-base">
                      {advantage.text1}
                      <br className="hidden md:block"></br> {advantage.text2}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
